
import { defineComponent, nextTick, onBeforeMount, onMounted, ref, watch } from 'vue';
import OpenOtherApi from '@/api/OpenOtherApi'
import { isEmpty } from '@/utils/tool.util';

export default defineComponent({
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    who: {
      type: String
    }, // 类型
    whoid: Number,
    notAllowAdd: Boolean // 不可添加
  },
  setup (props, { emit }) {
    const selectedTags = ref<any>([])
    const options = ref([])
    const visible = ref(true)

    watch(
      () => props.tags,
      (tags) => {
        selectedTags.value = tags.map((tag: any) => ({
          label: tag.name,
          value: tag.id,
          key: tag.id,
          option: { key: tag.id, value: tag.id, disabled: false, label: tag.name }
        }))
      }
    )

    watch(
      () => selectedTags.value,
      (n) => {
        emit('tagChange', n)
      },
      {
        deep: true
      }
    )

    function loadTags (keyword?: string) {
      if (keyword) {
        OpenOtherApi.getTags(keyword).then(res => {
          if (res.tags.length === 0) return
          options.value = res.tags
        })
      } else if (props.who === 'ticket' || props.who === 'chat' || props.who === 'robot' || props.who === 'knowledge') {
        OpenOtherApi.getTicketTags().then(res => {
          options.value = res
        })
      } else if (props.who === 'user') {
        OpenOtherApi.getUserTags().then(res => {
          options.value = res
        })
      } else if (props.who === 'user_group') {
        OpenOtherApi.getUserGroupTags().then(res => {
          options.value = res
        })
      }
    }

    function handleSearch (val) {
      loadTags(val)
    }

    function handleDeselect (value, option) {
      if (value.value) {
        deleteTagRelation(value.value)
      }
    }

    function handleSelect (value, option) {
      if (isEmpty(option)) return
      saveTagRelation(option.value, option.label)
    }

    function deleteTagRelation (tagId: number, tagName?: string) {
      if (!props.whoid) return
      if (props.who === 'user') {
        return OpenOtherApi.deleteUserRelationTag({
          tagId,
          userId: props.whoid
        })
      } else if (props.who === 'ticket') {
        return OpenOtherApi.deleteTicketRelationTag({
          tagId,
          ticketId: props.whoid,
          tagName
        })
      } else if (props.who === 'user_group') {
        return OpenOtherApi.deleteUserGroupRelationTag({
          tagId,
          userGroupId: props.whoid
        })
      } else if (props.who === 'chat') { 
        return OpenOtherApi.deleteChatRelationTag({
          tagId,
          chatId: props.whoid
        })
      }
    }

    function saveTagRelation (tagId: number, tagName: string) {
      if (!props.whoid) return
      if (['user', 'ticket', 'user_group', 'chat'].indexOf(props.who || '') === -1) return
      if (props.who === 'user') {
        return OpenOtherApi.saveUserRelationTag({
          tagId,
          userId: props.whoid
        })
      } else if (props.who === 'ticket') {
        return OpenOtherApi.saveTicketRelationTag({
          tagId,
          ticketId: props.whoid,
          tagName
        })
      } else if (props.who === 'user_group') {
        return OpenOtherApi.saveUserGroupRelationTag({
          tagId,
          userGroupId: props.whoid
        })
      } else if (props.who === 'chat') { 
        return OpenOtherApi.saveChatRelationTag({
          tagId,
          chatId: props.whoid
        })
      }
    }

    function handleInput (e) {
      e.target.value = e.target.value.trim()
      if (e.code === 'Space' || e.keyCode === 32) {
        const keyword = e.target.value
        if (!keyword) return
        for (let i = 0; i < selectedTags.value.length; i++) {
          const item = selectedTags.value[i]
          if (typeof item.label === 'string' && item.label === keyword) {
            return
          }
          if (typeof item.label === 'object' && item.label[0].children === keyword) {
            return
          }
          if (item.option && item.option.label === keyword) {
            return
          }
        }
        e.target.value = ''
        OpenOtherApi.addTag(keyword).then(res => {
          selectedTags.value.push({ 
            label: keyword, 
            value: res.id, 
            key: res.id, 
            option: { key: res.id, value: res.id, disabled: false, label: keyword }
          })
          saveTagRelation(res.id, keyword)
        })
      }
    }

    onBeforeMount(() => {
      loadTags()
    })

    return {
      visible,
      selectedTags,
      options,
      handleSearch,
      handleSelect,
      handleDeselect,
      handleInput
    }
  }
})
